import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSAData } from '../../../actions';
import { parseWSMessage } from '../../../utils/wsMessage';

// Normalize the message for `tel://...-adr` topics
const normalizeMessage = message => {
  const topic = message.topic;
  if (topic.startsWith('tel://') && topic.endsWith('-adr')) {
    return {
      ...message,
      topic: topic.split('-adr')[0],
    };
  }
  return { ...message };
};

/**
 * Custom hook that allows websocket to look at a message's category.
 * If it's an acceptable category, the message information will get added
 * to SAdata
 */
const useHandleMessageCategory = () => {
  const StreamWS = window.__RSOS?.streamWS?.instance;
  const permissions = useSelector(
    state => state.sinatra.user?.currentRole.permissions,
  );

  const normalizedPermissions = permissions.map(permission => {
    if (permission === 'PROFILE_INFO') {
      return 'medicalert';
    }
    return permission.replace(/^_/, '').toLowerCase();
  });

  const dispatch = useDispatch();

  const handleAcceptableCategory = useCallback(
    message => {
      const normalizedMessage = normalizeMessage(message);
      const parsedMessage = parseWSMessage(normalizedMessage);
      if (normalizedPermissions.includes(parsedMessage.category)) {
        dispatch(addSAData(normalizedMessage));
      }
    },
    [dispatch, normalizedPermissions],
  );

  useEffect(() => {
    if (StreamWS) {
      StreamWS.addOnMessageCallback({
        handleAcceptableCategory,
      });

      return () => {
        StreamWS.removeOnMessageCallback('handleAcceptableCategory');
      };
    }
  }, [StreamWS, handleAcceptableCategory]);

  return null;
};

export default useHandleMessageCategory;
